<script setup>
import Spinner from '@/components/ui/Spinner.vue'
import ProjectTile from './ProjectTile.vue'

/**
 * Covers the page between "switch requested" and the reload that lands in
 * the other workspace. Without it the old workspace's streams stay on screen for
 * a second or two while the sidebar already says "Switching…", which reads as
 * the switch having failed.
 */
defineProps({
  project: {
    type: Object,
    default: null,
  },
})
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-opacity duration-150 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
    >
      <div
        v-if="project"
        class="fixed inset-0 z-[70] flex items-center justify-center bg-surface-1/90 backdrop-blur-sm"
        role="status"
        aria-live="polite"
      >
        <div class="flex flex-col items-center gap-4 px-6 text-center">
          <ProjectTile :name="project.name" :color="project.color" size="size-14" textClass="text-xl" rounded="rounded-xl" />
          <div>
            <p class="text-base font-semibold text-white mb-1">Switching to {{ project.name }}…</p>
            <p class="text-tiny text-surface-7 mb-0">Loading its streams, videos and members.</p>
          </div>
          <Spinner spinner-color="var(--c-surface-6)" spinner-size="16px" />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
